import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { manifestoChapters } from '../data/mock';

const ManifestoSection = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });

  return (
    <section ref={containerRef} className="py-32 bg-gradient-to-b from-white to-purple-50/30">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Manifesto Kami
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Prinsip yang membimbing misi kami
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto space-y-32">
          {manifestoChapters.map((chapter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="relative"
            >
              <div className="flex flex-col md:flex-row gap-12 items-start">
                {/* Number */}
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="flex-shrink-0"
                >
                  <div className="text-9xl font-bold text-purple-200/50 leading-none">
                    {chapter.number}
                  </div>
                </motion.div>

                {/* Content */}
                <div className="flex-1 pt-6">
                  <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                    {chapter.title}
                  </h3>
                  <p className="text-xl text-gray-600 leading-relaxed">
                    {chapter.content}
                  </p>
                </div>
              </div>

              {/* Decorative line */}
              {index < manifestoChapters.length - 1 && (
                <motion.div
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  className="h-px bg-gradient-to-r from-transparent via-purple-200 to-transparent mt-32"
                  style={{ originX: 0 }}
                />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;